import ListPayments from './ListPayments/ListPayments';
import { aboutItems } from '../../data/data';
import Button from '../Button/Button';
import { SectionsProps } from '../../types/types';
const Payments = ({ openModal }: SectionsProps) => {
  return (
    <section className='payments'>
      <div className='payments__container grid-fons'>
        <h1 className='payments__title title'>
          Simplifying
          <span className='title color'> Cross-Border Payments</span>
        </h1>
        <div className='payments__inner'>
          {aboutItems.map((item) => (
            <p key={item.id} className='payments__text text-large'>
              {item.text}
            </p>
          ))}
        </div>
        <Button className='payments__button' onClick={openModal}>
          Contact us
        </Button>
        <ListPayments className='payments-list' />
      </div>
    </section>
  );
};
export default Payments;
